<template>
  <div id="Modal">
    <div class="popup">
      <div class="title">
        <slot name="title"/>
      </div>
      <div class="content">
        <slot name="content"/>
      </div>
      <div class="buttons">
        <slot name="buttons"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['title', 'content', 'button']
}
</script>

<style lang="scss" scoped>
#Modal {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: inherit;
  height: 100vh;
  margin: auto;
  background-color: rgba(51, 51, 51, 0.6);
  z-index: 999;

  .popup {
    position: relative;
    width: calc(100% - 50px);
    height: auto;
    background-color: #ffffff;
    margin-top: 0.5rem;
    overflow: hidden;
    border-radius: 8px;
    animation: modal-popup-show 0.3s;

    /*Slot*/
    .title > div, .content > div, .buttons > div {
      width: 100%;
    }
    .title > div, {
      width: 100%;
      font-size: 18px;
      text-align: center;
      font-weight: 900;
      line-height: 1.67;
      b {
        font-weight: 700;
      }
    }
    .content > div {
      width: 100%;
      font-size: 18px;
      text-align: center;
      line-height: 1.67;
      color: #333333;
      b {
        font-weight: 900;
      }
    }
    .buttons > div {
      width: 100%;
      background-color: #d7e1ea;
      font-weight: 900;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      button {
        height: 60px;
        font-weight: 900;
        font-size: 20px;
      }
    }
  }
}
</style>
